import {useId, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

interface IProps {
    useVisibilityTracking: boolean;
}

export const useElementViewportShowingUpStatus = ({useVisibilityTracking}: IProps) => {
    const containerId = useId();
    const [isWaitingForElementShownInViewPort, setIsWaitingForElementShownInViewPort] = useState(useVisibilityTracking);

    useElementWasVisible({
        ids: [containerId],
        onElementVisible: () => {
            setIsWaitingForElementShownInViewPort(false);
        },
        once: true,
        threshold: 0.05,
        disabled: !useVisibilityTracking
    });

    return {
        containerId,
        isWaitingForElement: useVisibilityTracking && isWaitingForElementShownInViewPort
    };
};
import {useId, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

interface IProps {
    useVisibilityTracking: boolean;
}

export const useElementViewportShowingUpStatus = ({useVisibilityTracking}: IProps) => {
    const containerId = useId();
    const [isWaitingForElementShownInViewPort, setIsWaitingForElementShownInViewPort] = useState(useVisibilityTracking);

    useElementWasVisible({
        ids: [containerId],
        onElementVisible: () => {
            setIsWaitingForElementShownInViewPort(false);
        },
        once: true,
        threshold: 0.05,
        disabled: !useVisibilityTracking
    });

    return {
        containerId,
        isWaitingForElement: useVisibilityTracking && isWaitingForElementShownInViewPort
    };
};
